export const validateUser = user => {

  //console.log('[ValidateUser] - START: ', user, user.name);
    // numberLocale
    if (user && user.userPreferences) {
      if (!user.userPreferences.numberLanguage) {
        user.userPreferences.numberLanguage = 'de';
      }
      if (!user.userPreferences.viewTypes) {
        user.userPreferences.viewTypes = {
          collectionView: 'slider',
          collectionDetailView: 'grid'
        };
      }

      // templates
      if (!user.userPreferences.templates) {
        user.userPreferences.templates = {
          default: null,
          userTemplates: []
        };
      }     

      // theme
      if (!user.userPreferences.theme) {
        user.userPreferences.theme = 'light';
      }

      // editor display view
      if (!user.userPreferences.editor) {
        user.userPreferences.editor = {
          displayType: 'custom',
          displayWidth: 800,
          displayHeight: 600,
          displayScale: 1,
          displayPreview: false
        };
      }

      // newsletterConsent
      if (!user.newsletterConsent) {
        user.newsletterConsent = {
          accepted: false,
          date: null
        }
      }
    }

    //console.log('[ValidateUser] - END: ', user, user.name);
    return user;
  };
